/**
 * Klaviyo Environment Configuration Utility
 * Helper functions to get VAPID keys from environment
 */

/**
 * Get the Klaviyo VAPID public key from environment variables
 * VITE_PUBLIC_VAPID_KEY should be set to the public key from canesmeno-credentials.env
 */
export const getKlaviyoVapidKey = (): string => {
  const vapidKey = import.meta.env.VITE_PUBLIC_VAPID_KEY;

  if (!vapidKey) {
    console.warn(
      "Klaviyo VAPID key is not configured. Set VITE_PUBLIC_VAPID_KEY in your .env file",
    );
    return "";
  }

  return vapidKey;
};

/**
 * Validate VAPID key format (base64 encoded)
 */
export const isValidVapidKey = (key: string): boolean => {
  if (!key || typeof key !== "string") {
    return false;
  }

  // VAPID keys should be base64url encoded and typically 87-88 characters
  const vapidKeyRegex = /^[A-Za-z0-9_-]+$/;
  return vapidKeyRegex.test(key) && key.length >= 80;
};

/**
 * Check if Klaviyo is loaded in the window object
 */
export const isKlaviyoLoaded = (): boolean => {
  return typeof (window as any).klaviyo !== "undefined";
};

/**
 * Get browser support status for web push notifications
 */
export const getPushNotificationSupport = (): {
  serviceWorker: boolean;
  pushManager: boolean;
  notification: boolean;
  supported: boolean;
} => {
  return {
    serviceWorker: "serviceWorker" in navigator,
    pushManager: "PushManager" in window,
    notification: "Notification" in window,
    supported:
      "serviceWorker" in navigator &&
      "PushManager" in window &&
      "Notification" in window,
  };
};
